module.exports = {
      id: "phone-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#phone",
      toString: function () {
        return this.url;
      }
    }